import { SUB_PAGES } from "../../../../interfaces/RegionalPage";
import { INDIA_EXPERIENCED_HIRES } from "./_experienced_hires";

export const INDIA_SUB_PAGES: SUB_PAGES[] = [INDIA_EXPERIENCED_HIRES];
